import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';
import {DragSource, DropTarget} from 'react-dnd';
import {getEmptyImage} from 'react-dnd-html5-backend';
import ReportCard from 'common/components/report-card';
import * as DraggableItemType from 'common/components/dashboard/constants/draggable-item-type';

const DRAG_END_EVENTS = ['mouseup', 'dragend'];

const cardSource = {
  beginDrag(props, monitor, component) {
    const id = props.id;
    const {report, index} = props.findCard(id);
    const width = findDOMNode(component).children[0].offsetWidth;
    props.beginDrag(index);
    return {id, report, width};
  },

  endDrag(props) {
    props.dropzone(null, null);
  },
};

const collectDrag = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
});

const cardTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const draggedId = monitor.getItem().id;
    const overId = props.id;
    const over = props.findCard(overId);
    const dragged = props.findCard(draggedId);

    if (dragged.colIndex === over.colIndex) {
      if (draggedId !== overId) {
        const dragBefore = dragged.index > over.index ? over.index : null;
        const dragAfter = dragged.index < over.index ? over.index : null;
        props.dropzone(dragBefore, dragAfter);
      }
    } else {
      props.dropzone(over.index, null);
    }
  },
};

const collectDrop = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
});

class DraggableCard extends React.Component {
  static defaultProps = {
    disableConfig: false,
    forExport: false,
  };

  static propTypes = {
    beginDrag: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    disableConfig: PropTypes.bool,
    dropzone: PropTypes.func.isRequired,
    findCard: PropTypes.func.isRequired,
    forExport: PropTypes.bool,
    id: PropTypes.any.isRequired,
    isDragging: PropTypes.bool.isRequired,
    report: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    DRAG_END_EVENTS.forEach((event) =>
      window.addEventListener(event, this.onDragEnd),
    );
  }

  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }

  componentWillUnmount() {
    this.setState({dragged: false});
    DRAG_END_EVENTS.forEach((event) =>
      window.removeEventListener(event, this.onDragEnd),
    );
  }

  render() {
    const {
      report,
      isDragging,
      connectDragSource,
      connectDropTarget,
      disableConfig,
      forExport,
    } = this.props;

    const opacity = isDragging ? 0 : 1;

    return connectDropTarget(
      <div
        className={`${this.state.dragged ? 'ContainerCard--dragged' : ''}`}
        onMouseDown={this.onMouseDown}
        style={{opacity}}>
        <ReportCard
          connectDragSource={connectDragSource}
          disableConfig={disableConfig}
          forExport={forExport}
          isDragging={isDragging}
          report={report}
        />
      </div>,
    );
  }

  onDragEnd() {
    if (this.state.dragged) {
      this.setState({dragged: false});
    }
  }

  onMouseDown(event) {
    const $target = $(event.target);
    if (
      ($target.hasClass('CardHeader') ||
        $target.parents('.CardHeader').length) &&
      !$target.hasClass('DropdownMenu') &&
      !$target.parents('.DropdownMenu').length
    ) {
      this.setState({dragged: true});
    }
  }
}

// Intermediate drag source component
const ComponentDragSource = DragSource(
  DraggableItemType.CARD,
  cardSource,
  collectDrag,
)(DraggableCard);

// Export drag target
export default DropTarget(
  DraggableItemType.CARD,
  cardTarget,
  collectDrop,
)(ComponentDragSource);
